import React from 'react';

const PlusSvg = ({width = 20, height = 20, couleur = "white"}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 40 40" fill="none">
        <path d="M20 5.25V34.5" stroke={couleur} strokeWidth="4"/>
        <path d="M5.37598 19.875H34.6245" stroke={couleur} strokeWidth="4"/>
    </svg>
);

export default PlusSvg;
